import { ApiUrl } from "../../components/Common/ApiUrl";
import { Constants } from "../../components/Common/Constants";
import httpServiceInstance from "../../helper/HttpService";

export const forceAdd = async (data) => {
  const response = await httpServiceInstance.post(ApiUrl.FORCE, data);
  return response;
};

export const forceEdit = async (data) => {
  const response = await httpServiceInstance.patch(ApiUrl.FORCE, data);
  return response;
};

export const forceRemove = async (id) => {
  const response = await httpServiceInstance.delete(ApiUrl.FORCE + `/${id}`);
  return response;
};

export const force = async (data) => {
  const response = await httpServiceInstance.get(
    `${ApiUrl.FORCE}${
      data?.skipPagination
        ? `?${Constants.paginationFalse}`
        : `?skip=${data?.skip || 0}&limit=${
            data?.limit || Constants.limitCount
          }`
    }${data && data?.search ? `&search=${data?.search}` : ""}${
      data?.status ? `&status=${data?.status}` : ""
    }`
  );
  return response;
};
